// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import AsyncComputed from 'vue-async-computed'
import Vuelidate from 'vuelidate'
import confirmDialog from 'vuetify-vuejs-confirmdialog'
import { formatDate } from './helpers/formatters'
import 'vuetify/dist/vuetify.min.css'
import 'babel-polyfill'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(Vuetify)
Vue.use(Vuelidate)
Vue.use(confirmDialog)
Vue.use(AsyncComputed)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.filter('date', formatDate)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  if (to.path !== '/login') {
    if (isLoggedIn) {
      next()
    } else {
      next('login')
    }
  } else {
    store.commit('auth/resetToken')
    store.commit('auth/resetUser')
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    this.$vuetify.theme.primary = '#f8a135'
    this.$vuetify.theme.highlight = '#BDBDBD'
    this.$vuetify.theme.secondary = '#212121'
    this.$vuetify.theme.error = '#ca7000'
  }
})



// WEBPACK FOOTER //
// ./src/main.js